import * as yup from 'yup';

import { donationsCategoryResultSchema, QuerySortEnum } from '@/core/types/donation';
import { adminResultSchema, cityResultSchema, countryResultSchema, subResultSchema } from '@/core/types/geo';

export enum SavedSearchOrigin {
  SEARCH = 'search',
  INTEREST = 'interest',
}

export const savedSearchResult = yup.object({
  hash: yup.string().nullable(),
  label: yup.string().nullable(),
  email: yup.boolean().nullable(),
  push: yup.boolean().nullable(),
  params: yup.object({
    cat: yup.array(yup.number().required()).optional(),
    giver: yup.string().optional(),
    loc: yup.string().optional(),
    published_at: yup.number().optional(),
    sort: yup.mixed<QuerySortEnum>().oneOf(Object.values(QuerySortEnum)),
    title: yup.string().optional(),
    distance: yup.number().optional(),
  }),
  created_at: yup.string().nullable(),
  origin: yup.mixed<SavedSearchOrigin>().oneOf(Object.values(SavedSearchOrigin)).required(),
  unread: yup.number().nullable(),
});

export type SavedSearchResult = yup.InferType<typeof savedSearchResult>;

export const savedSearchesResult = yup.object({
  searches: yup.array(savedSearchResult).required(),
  categories: yup.array(donationsCategoryResultSchema).required(),
  countries: yup.array(countryResultSchema).required(),
  admins: yup.array(adminResultSchema).required(),
  cities: yup.array(cityResultSchema).required(),
  subs: yup.array(subResultSchema).required(),
});

export type SavedSearchesResult = yup.InferType<typeof savedSearchesResult>;

export const savedSearchForm = yup.object({
  title: yup.string().optional(),
  cat: yup.array(yup.number().required()).optional(),
  loc: yup.string().optional(),
  distance: yup.number().optional(),
  lat: yup.number().optional(),
  lon: yup.number().optional(),
  published_at: yup.string().optional(),
  giver: yup.string().optional(),
  from: yup.number().optional(),
  size: yup.number().optional(),
  sort: yup.mixed<QuerySortEnum>().oneOf(Object.values(QuerySortEnum)),
  label: yup.string().required(),
  email: yup.boolean().required(),
  push: yup.boolean().required(),
  origin: yup.mixed<SavedSearchOrigin>().oneOf(Object.values(SavedSearchOrigin)).required(),
  tag: yup.string().optional(),
});

export type SavedSearchForm = yup.InferType<typeof savedSearchForm>;
